import React from "react";
import { Link } from "react-router-dom";
import { TrendingDown, CheckCheck } from "lucide-react";
import { fmtPoints } from "../data/mock";

function timeAgo(iso) {
  const m = Math.max(1, Math.round((Date.now() - new Date(iso)) / 60000));
  if (m < 60) return `${m}m ago`;
  const h = Math.round(m / 60);
  return h < 24 ? `${h}h ago` : `${Math.round(h / 24)}d ago`;
}

function NotificationItem({ n, onOpen }) {
  return (
    <Link to={`/search?from=${n.route.from}&to=${n.route.to}&date=${n.route.date}&flex=0`} onClick={onOpen} data-testid="notification-item" className={`block border-b border-slate-50 px-4 py-3 transition-colors hover:bg-slate-50 ${n.read ? "" : "bg-blue-50/50"}`}>
      <div className="flex items-start gap-3">
        <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-green-100 text-green-700"><TrendingDown className="h-3.5 w-3.5" /></span>
        <div className="min-w-0">
          <p className="text-sm font-semibold text-slate-900">{n.title}</p>
          <p className="mt-0.5 text-xs text-slate-500">{n.body}</p>
          <p className="mt-1 text-[11px] text-slate-400">Target {fmtPoints(n.targetPoints)} · {timeAgo(n.createdAt)}</p>
        </div>
      </div>
    </Link>
  );
}

function EmptyState({ isPro }) {
  if (!isPro) {
    return (
      <div className="px-4 py-8 text-center" data-testid="notifications-pro-upsell">
        <TrendingDown className="mx-auto h-8 w-8 text-slate-300" />
        <p className="mt-2 text-sm font-semibold text-slate-700">Alerts are a PRO feature</p>
        <p className="text-xs text-slate-500">Set targets on wishlist deals now — <Link to="/pricing" className="font-semibold text-blue-600 hover:underline">go PRO</Link> to start receiving price-drop notifications.</p>
      </div>
    );
  }
  return (
    <div className="px-4 py-8 text-center">
      <TrendingDown className="mx-auto h-8 w-8 text-slate-300" />
      <p className="mt-2 text-sm font-semibold text-slate-700">No price drops yet</p>
      <p className="text-xs text-slate-500">Set a target on a <Link to="/wishlist" className="font-semibold text-blue-600 hover:underline">wishlist</Link> deal and we’ll watch it for you.</p>
    </div>
  );
}

export default function NotificationList({ items, unread, onMarkRead, onOpen, isPro }) {
  return (
    <div data-testid="notification-dropdown" className="absolute right-0 mt-2 w-80 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-xl shadow-slate-200/60">
      <div className="flex items-center justify-between border-b border-slate-100 px-4 py-2.5">
        <span className="text-sm font-bold text-slate-900">Price alerts</span>
        {unread > 0 && (
          <button onClick={onMarkRead} data-testid="notification-mark-read" className="flex items-center gap-1 text-xs font-semibold text-blue-600 hover:underline"><CheckCheck className="h-3.5 w-3.5" /> Mark all read</button>
        )}
      </div>
      <div className="max-h-96 overflow-auto">
        {items.length === 0 ? <EmptyState isPro={isPro} /> : items.map((n) => <NotificationItem key={n.id} n={n} onOpen={onOpen} />)}
      </div>
    </div>
  );
}
